import { connect } from 'react-redux'
import Modal, { SimpleModal } from './Modal'

function mapStateToProps(state) {
  return {
    isOpen: state.modal
  }
}

export { SimpleModal }
export default connect(mapStateToProps)(Modal)



// WEBPACK FOOTER //
// ./src/app/elements/Modal/index.js